import cx from 'classnames';
import { withProps } from 'recompose';

import { defaultSize } from 'sharedParts/config/blockConfig/questionNumeric';

import styles from './withNumericRatingItemStyle.scss';

export default withProps(({ block: { size = defaultSize } }) => ({
  ratingContainerClassName: styles.container,
  ratingItemClassName: cx(styles.ratingItem, styles[size]),
}));
